import { api } from '@/lib/api'

import { AccountDetails } from '../types'

export function getDefaultAccountDetails() {
  return api.get<AccountDetails>('/v1/me/bank-accounts')
}
